import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const RolesPage = lazy(() => import('./pages/RolesPage'));

export const RolesRoutes: RouteObject = {
  path: 'roles',
  children: [
    { path: '', element: <RolesPage />, handle: { crumb: 'Roles' } },
  ],
};
